export default "__VITE_ASSET__ea6f85f5__"